import { render } from "./PremisesTable.vue?vue&type=template&id=d269fa70"
import script from "./PremisesTable.vue?vue&type=script&lang=js"
export * from "./PremisesTable.vue?vue&type=script&lang=js"

import "./PremisesTable.vue?vue&type=style&index=0&id=d269fa70&lang=scss"

import exportComponent from "/Users/dmytrokulyk/Documents/Development/GreenHub/dsp-f-2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__